import React from 'react'
import ErrorPage from './ErrorPage'

function DeleteAccount() {
  return (
    <div>
        <ErrorPage type="" typeString="To delete account" msg="Contect tp your college admin" path='/' />
    </div>
  )
}

export default DeleteAccount